import { Routes, Route } from 'react-router-dom';
import { permissoesRotas } from '../config/rotasRolesPermitidas';

// Indicador
import Graficos from './Graficos';
import AjustarIndicadores from './AjustarIndicadores';
import InformarIndicadoresPlanilha from './InformarIndicadoresPlanilha';

// Pendências
import ResponderPendencias from './ResponderPendencias';
import AcompanharPendencias from './AcompanharPendencias';

// Relatórios
import GerarRelatorios from './GerarRelatorios';

// Admin & Configurações
import Home from './Home';
import PrivateRoute from './RotasPrivadas';
import TelaInformativa from './TelaInformativa';
import ConfiguracoesGerais from './ConfiguracoesGerais';

// Relatório de Acompanhamento
import CriaFormularioAcompanhamento from './CriaFormularioAcompanhamento';
import RelatoriosEnviados from './relatorioAcompanhamento/RelatoriosEnviados';
import VerificaRelatorio from './relatorioAcompanhamento/VerificaRelatorio';
import DownloadRelatorioAcompanhamento from './DownloadRelatorioAcompanhamento';

function Rotas() {

    console.log('### Iniciando ROTAS ###');

    return (
        <Routes>
            {/*------ Rodas publicas ------*/}

            <Route path='/'
                element={<Home />} />

            <Route path='/graficos'
                element={<Graficos />} />

            <Route path='/informativos'
                element={<TelaInformativa
                    cabecalho=''
                    mensagem=''
                    pathRedirect=''
                    buttonMessage=''
                    urlExterna={false} />}
            />

            {/*------ Rodas privadas ------*/}

            {/* INDICADOR */}

            <Route path='/indicador/informar-por-planilha'
                element={
                    <PrivateRoute acceptedRoles={permissoesRotas['informaIndicador']}>
                        <InformarIndicadoresPlanilha />
                    </PrivateRoute>}
            />

            {/* <Route path='/indicador/ajustar'
                element={
                    <PrivateRoute acceptedRoles={permissoesRotas['ajustaIndicador']}>
                        <AjustarIndicadores />
                    </PrivateRoute>}
            /> */}

            {/* RELATÓRIO DE ACOMPANHAMENTO */}

            <Route path='/relatorio-acompanhamento/criar'
                element={
                    <PrivateRoute acceptedRoles={permissoesRotas['criaRelAcomp']}>
                        <CriaFormularioAcompanhamento />
                    </PrivateRoute>}
            />

            {/* <Route path='/relatorio-acompanhamento/enviados'
                element={<PrivateRoute acceptedRoles={permissoesRotas['relAcompEnviados']}>
                    <RelatoriosEnviados />
                </PrivateRoute>}
            /> */}

            {/* <Route path='/relatorio-acompanhamento/verificacao/:relatorioAcompanhamentoId'
                element={<PrivateRoute acceptedRoles={permissoesRotas['relAcompEnviados']}>
                    <VerificaRelatorio />
                </PrivateRoute>}
            /> */}


            <Route path='relatorio-acompanhamento/download'
                element={
                    <PrivateRoute acceptedRoles={permissoesRotas['downloadRelAcomp']}>
                        <DownloadRelatorioAcompanhamento />
                    </PrivateRoute>}
            />

            {/* PENDÊNCIAS */}

            <Route path='/relatorio-acompanhamento/pendencias/responder'
                element={<PrivateRoute acceptedRoles={permissoesRotas['respondePendencia']}>
                    <ResponderPendencias />
                </PrivateRoute>}
            />

            {/* <Route path='/relatorio-acompanhamento/pendencias/acompanhar'
                element={<PrivateRoute acceptedRoles={permissoesRotas['acompanhaPendencias']}>
                    <AcompanharPendencias />
                </PrivateRoute>}
            /> */}

            {/* RELATÓRIOS */}

            <Route path='/relatorios/gerar'
                element={<PrivateRoute acceptedRoles={permissoesRotas['gerarRelatorios']}>
                    <GerarRelatorios />
                </PrivateRoute>}
            />

            {/* ADMIN */}

            <Route path='/admin/configuracoes-gerais'
                element={<PrivateRoute acceptedRoles={permissoesRotas['configuracoesGerais']}>
                    <ConfiguracoesGerais />
                </PrivateRoute>}
            />

        </Routes>
    );
}

export default Rotas;
